import lostPasswordModule from './lost-password.module'
export default lostPasswordModule.name
